
import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { keyframes, ListItemText, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';

const rippleAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
`;

const borderAngleRotate = keyframes`
  from { --border-angle: 0deg; }
  to { --border-angle: 360deg; }
`

const styleRipple = (hasRipple, isActive, theme) => {
    return (hasRipple && isActive === 0 ? {

    } : {});
}

const ICONBUTTON = styled(Button)(({ theme, isActive, open, useStroke, useFill, hasRipple }) => {
    // console.log(isActive, "isActive")
    if (useStroke && useFill) {
        return ({
            backgroundColor: 'transparent',
            textTransform: 'none',
            minWidth: 'calc(4 * 0.75rem)',
            height: 'calc(3 * 0.75rem)',
            // padding: '0.75rem',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            justifyContent: 'center',
            ...(styleRipple(hasRipple, isActive, theme)),
            '& svg': {
                transition: 'stroke 0.3s ease',
                stroke: useStroke ? (isActive ? theme.palette.customColors.whiteBG : 'rgba(255, 255, 255, 0.92)') : 'transparent',
                fill: useFill ? (isActive ? theme.palette.customColors.whiteBG : 'rgba(255, 255, 255, 0.92)') : "transparent",

                width: 'calc(2 * 0.75rem)',
                height: 'calc(2 * 0.75rem)',
                margin: { md: "auto" }
            },
            '&:hover': {
                backgroundColor: "transparent",
                // backgroundColor: theme.palette.customColors.indigo600,
                '& svg': {
                    stroke: useStroke ? theme.palette.customColors.whiteBG : "transparent",
                    fill: useFill ? theme.palette.customColors.whiteBG : "transparent",
                }
            },
        })
    }
    else if (useStroke) {
        return ({
            backgroundColor: 'transparent',
            textTransform: 'none',
            minWidth: 'calc(4 * 0.75rem)',
            height: 'calc(3 * 0.75rem)',
            // padding: '0.75rem',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            justifyContent: 'center',
            ...(styleRipple(hasRipple, isActive, theme)),
            '& svg': {
                transition: 'stroke 0.3s ease',
                stroke: isActive ? theme.palette.customColors.whiteBG : 'rgba(255, 255, 255, 0.92)',
                fill: "transparent",

                width: 'calc(2 * 0.75rem)',
                height: 'calc(2 * 0.75rem)',
                margin: { md: "auto" }
            },
            '&:hover': {
                backgroundColor: "transparent",
                // backgroundColor: theme.palette.customColors.indigo600,
                '& svg': {
                    stroke: theme.palette.customColors.whiteBG,
                    fill: "transparent",
                }
            },
        })
    }
    else if (useFill) {
        return ({
            backgroundColor: 'transparent',
            textTransform: 'none',
            minWidth: 'calc(4 * 0.75rem)',
            height: 'calc(3 * 0.75rem)',
            // padding: '0.75rem',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            justifyContent: 'center',
            ...(styleRipple(hasRipple, isActive, theme)),
            '& svg': {
                transition: 'stroke 0.3s ease',
                stroke: 'transparent',
                fill: isActive ? theme.palette.customColors.whiteBG : 'rgba(255, 255, 255, 0.92)',

                width: 'calc(2 * 0.75rem)',
                height: 'calc(2 * 0.75rem)',
                margin: { md: "auto" }
            },
            '&:hover': {
                backgroundColor: "transparent",
                // backgroundColor: theme.palette.customColors.indigo600,
                '& svg': {
                    stroke: "transparent",
                    fill: theme.palette.customColors.whiteBG,
                }
            },
        })
    }
});

const NavIconButton = ({ item, isActive, open }) => {
    const theme = useTheme();
    const matchesUpMd = useMediaQuery(theme.breakpoints.up('md'));
    return (
        <>
            {!open ?
                <ICONBUTTON
                    disableRipple
                    className={`${item?.hasRipple ? "" + ` ${isActive ? "menu-item-active" : ""}` : ""}`}
                    isActive={isActive ? 1 : 0}
                    disabled={item?.disabled}
                    sx={{
                        display: 'flex',
                        justifyContent: "flex-start",
                        width: "100%"
                    }}
                    useStroke={item?.useStroke}
                    useFill={item?.useFill}
                    hasRipple={item?.hasRipple}
                    open={open}>
                    <item.icon
                        style={{
                            width: 'calc(1.5 * 0.75rem)',
                            height: 'calc(2 * 0.75rem)',
                            margin: matchesUpMd ? "auto" : ""
                        }} />
                    {open
                        && <ListItemText
                            sx={{
                                maxWidth: "min-content"
                            }}>
                            {item?.title}
                        </ListItemText>}
                </ICONBUTTON>
                :
                <ICONBUTTON
                    disableRipple
                    className={`${item?.hasRipple ? "" : ""}`}
                    isActive={isActive ? 1 : 0}
                    disabled={item?.disabled}
                    sx={{
                        display: 'flex',
                        justifyContent: "flex-start",
                        width: "100%"
                    }}
                    useStroke={item?.useStroke}
                    useFill={item?.useFill}
                    hasRipple={item?.hasRipple}
                    open={open}
                >
                    <item.icon
                        style={{
                            width: 'calc(1.5 * 0.75rem)',
                            height: 'calc(2 * 0.75rem)' + ` ${isActive ? "menu-item-active" : ""}`,
                            flexShrink: 0,
                            margin: matchesUpMd && !open ? "auto" : 0
                        }}
                    />
                    {open
                        && <ListItemText
                            sx={{
                                maxWidth: "max-content"
                            }}>
                            {item?.title}
                        </ListItemText>}
                </ICONBUTTON>}
        </>
    )
};

export { NavIconButton };
